import React from 'react'
import { Link } from 'react-router-dom'
import { FaExclamationTriangle } from 'react-icons/fa'

const Notfoundpage = () => {
  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-slate-100 px-6 py-24 sm:py-32 lg:px-8">
      <FaExclamationTriangle className="text-red-500 text-6xl mb-4" />
      <div className="text-center">
        <p className="text-lg font-bold text-red-600">404</p>
        <h1 className="mt-2 text-3xl font-extrabold text-gray-900 sm:text-4xl">
          Page Not Found
        </h1>
        <p className="mt-3 text-base text-gray-600">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center rounded-lg bg-black px-5 py-3 text-sm font-semibold text-white shadow-lg transition hover:bg-slate-900 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2"
          >
            Go Back Home
          </Link>
        </div>
      </div>
    </main>

  )
}

export default Notfoundpage
